import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "m-collectible",
  class: "manifold"
}

import { Buy, Countdown, Inventory } from "@/components";
import { useStore } from "@/composables/useStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'CollectibleView',
  setup(__props) {

const store = useStore();

return (_ctx: any,_cache: any) => {
  return (_unref(store).loaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(Buy)),
        _createVNode(_unref(Inventory)),
        _createVNode(_unref(Countdown))
      ]))
    : _createCommentVNode("", true)
}
}

})